import { DOCUMENT } from '@angular/platform-browser';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

const EMPLOYEE_STANDARD_BODY_CLASS = 'employee-standard-overrides-open';

@Injectable()
export class EmployeeStandardOverridesBackdropService {
  private readonly renderer: Renderer2;

  constructor(
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public add(): void {
    this.renderer.addClass(this.document.body, EMPLOYEE_STANDARD_BODY_CLASS);
  }

  public remove(): void {
    this.renderer.removeClass(this.document.body, EMPLOYEE_STANDARD_BODY_CLASS);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/popups/employee-standard-overrides/services/employee-standard-overrides-backdrop.service.ts